import { render, staticRenderFns } from "./OilImportTableRow.vue?vue&type=template&id=50cf052c&scoped=true"
import script from "./OilImportTableRow.vue?vue&type=script&lang=ts"
export * from "./OilImportTableRow.vue?vue&type=script&lang=ts"
import style0 from "./OilImportTableRow.vue?vue&type=style&index=0&id=50cf052c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf052c",
  null
  
)

export default component.exports